import React, { useEffect, useRef, useState, useCallback } from 'react';
import classNames                                          from 'classnames';
import { useNotification }                                 from '../../providers/notification';
import CloseIcon                                           from '../icons/CloseIcon';

const NotificationModal = function() {
  const {
          hideModal,
          open,
          title,
          description,
        }               = useNotification();
  const [show, setShow] = useState(false);
  const modalRef        = useRef(null);

  const closeModal = useCallback(() => {
    show && setShow(false);
    hideModal();
  }, [show, hideModal]);

  const keyDown = useCallback(
    ({ keyCode }) => {
      if (open && show && keyCode === 27) {
        closeModal();
      }
    },
    [open, show, closeModal],
  );

  const handleClickOutside = useCallback(
    (event) => {
      if (
        open &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        closeModal();
      }
    },
    [open, closeModal],
  );

  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show, handleClickOutside, keyDown]);

  useEffect(() => {
    if (open) {
      if (!show) {
        setTimeout(() => {
          setShow(true);
        }, 100);
      }
    }
  }, [open]);

  useEffect(() => {
    document.body.classList.toggle('fixed', open && show);
  }, [open, show]);

  return (
    <div
      className={classNames('modal-overlay', 'notification-modal-overlay', {
        show,
      })}
    >
      <div className={classNames('modal', 'notification-modal')} ref={modalRef}>
        <span className={'close'} onClick={closeModal}>
          <CloseIcon />
        </span>
        <p className={'title'}>
          {title}
        </p>
        <p className={'description'}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default NotificationModal;
